import React from "react";
import { motion } from "framer-motion";

const STEPS = [
    {
        n: "01",
        title: "Découverte",
        desc: "On apprend à connaître votre marque, vos objectifs et votre audience. Un appel sans engagement pour cadrer le projet.",
    },
    {
        n: "02",
        title: "Stratégie & concept",
        desc: "Nous proposons une direction visuelle claire, alignée sur votre positionnement et vos ambitions commerciales.",
    },
    {
        n: "03",
        title: "Création",
        desc: "Photo, vidéo, design, développement. Tout est produit en interne avec un soin maniaque du détail.",
    },
    {
        n: "04",
        title: "Lancement & suivi",
        desc: "Mise en ligne, formation, et un accompagnement continu pour faire évoluer vos visuels avec votre entreprise.",
    },
];

export default function Process() {
    return (
        <section
            id="processus"
            data-testid="process-section"
            className="relative py-24 md:py-32 px-6 md:px-12 lg:px-16 border-t border-scd bg-elev"
        >
            <div className="grid md:grid-cols-12 gap-8 mb-14 md:mb-20">
                <div className="md:col-span-4">
                    <span className="label-eyebrow text-yellow">— Processus</span>
                </div>
                <div className="md:col-span-8">
                    <h2 className="section-heading text-cream" data-testid="process-heading">
                        Quatre étapes,
                        <br />
                        <span className="text-yellow italic">zéro mauvaise surprise.</span>
                    </h2>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[rgba(250,247,241,0.15)]">
                {STEPS.map((s, i) => (
                    <motion.div
                        key={s.n}
                        initial={{ y: 40, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.2 }}
                        transition={{ duration: 0.6, delay: i * 0.08 }}
                        whileHover={{
                            y: -6,
                            transition: { duration: 0.3 },
                        }}
                        data-testid={`process-step-${s.n}`}
                        className="bg-scd p-8 md:p-10 min-h-[260px] flex flex-col justify-between group cursor-default"
                    >
                        <div className="flex items-start justify-between">
                            <motion.span
                                whileHover={{ scale: 1.1, rotate: -4 }}
                                transition={{ duration: 0.3 }}
                                className="font-display text-6xl text-yellow leading-none origin-bottom-left"
                            >
                                {s.n}
                            </motion.span>
                            <motion.div
                                animate={{
                                    scale: [1, 1.3, 1],
                                    transition: {
                                        duration: 2.4,
                                        repeat: Infinity,
                                        delay: i * 0.4,
                                        ease: "easeInOut",
                                    },
                                }}
                                className="w-3 h-3 bg-yellow rounded-full"
                            />
                        </div>
                        <div>
                            <h3 className="font-display text-2xl md:text-3xl text-cream">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-cream/70 text-sm leading-relaxed">
                                {s.desc}
                            </p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
